import { render, staticRenderFns } from "./onboarding.page.vue?vue&type=template&id=085b0195&scoped=true&"
import script from "./onboarding.page.vue?vue&type=script&lang=js&"
export * from "./onboarding.page.vue?vue&type=script&lang=js&"
import style0 from "./onboarding.page.vue?vue&type=style&index=0&id=085b0195&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085b0195",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VDivider,VStepper,VStepperContent,VStepperHeader,VStepperItems,VStepperStep})
